import { useEffect } from "react";
import { Supportedlocales } from "@motain/web-shared-hub/constants";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

function isSupportedLocale(
  locale: string,
): locale is keyof typeof Supportedlocales {
  return locale in Supportedlocales;
}

const getLocaleFromUrl = (pathname: string) => {
  const [firstSegment] = pathname.split("/").filter(Boolean);
  return isSupportedLocale(firstSegment) ? firstSegment : Supportedlocales.en;
};

export const useSetLocaleFromURL = () => {
  const { i18n } = useTranslation();
  const url = useLocation();
  const locale = getLocaleFromUrl(url.pathname);

  useEffect(() => {
    void i18n.changeLanguage(locale ?? "en");
  }, [i18n, locale]);
};
